export const messages = {
  captionOff: {
    defaultMessage: 'system-cc-off',
    id: 'fa.feature-gallery.caption.off',
  },
  captionOn: {
    defaultMessage: 'system-cc-on',
    id: 'fa.feature-gallery.caption.on',
  },
  unMute: {
    defaultMessage: 'system-audio-off',
    id: 'fa.feature-gallery.unmute',
  },
  mute: {
    defaultMessage: 'system-audio-on',
    id: 'fa.feature-gallery.mute',
  },
  pause: {
    defaultMessage: 'system-pause',
    id: 'fa.feature-gallery.pause',
  },
  play: {
    defaultMessage: 'system-play',
    id: 'fa.feature-gallery.play',
  },
  nextSlide: {
    defaultMessage: 'Next Slide',
    id: 'fa.feature-gallery.next',
  },
  previousSlide: {
    defaultMessage: 'Previous Slide',
    id: 'fa.feature-gallery.previous',
  },
  jumpTo: {
    defaultMessage: 'Go to slide',
    id: 'fa.feature-gallery.jumpTo',
  },
  currentSlide: {
    defaultMessage: 'This is the current slide - Slide',
    id: 'fa.feature-gallery.currentSlide',
  },
};
